import { Injectable } from '@angular/core';
import { BaseNotifier } from '../../notifiers/base-notifier';
import { Ref } from '../../providers/ref';
import { ChatLayoutState } from '../states/chat-layout-state';

@Injectable({ providedIn: 'root' })
export class ChatLayoutNotifier extends BaseNotifier<ChatLayoutState> {
  constructor(ref: Ref) {
    super(ref, {
      sidebarOpen: true,
      sidebarWidth: 300,
    });
  }

  toggleSidebar(): void {
    this.updateState(prev => ({ ...prev, sidebarOpen: !prev.sidebarOpen }));
  }
}
